import { render, staticRenderFns } from "./NoResults.html?vue&type=template&id=0356172b&scoped=true&"
import script from "./NoResults.js?vue&type=script&lang=js&"
export * from "./NoResults.js?vue&type=script&lang=js&"
import style0 from "./NoResults.scss?vue&type=style&index=0&id=0356172b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356172b",
  null
  
)

export default component.exports